import { match } from 'ts-pattern';

import { MessageMedium } from 'modules/graphql/types';
import noop from 'utils/noop';
import {
  useUpdateEmailTemplate,
  useUpdateSMSTemplate,
  useUpdatePushTemplate,
} from 'modules/templateEditor/hooks/updateTemplates';

const noOpHandlers = {
  onComplete: noop,
  onError: noop,
  onSuccess: noop,
};
export const useUpdateTemplateMedium = () => {
  const [updateEmailTemplate] = useUpdateEmailTemplate(noOpHandlers);
  const [updateSMSTemplate] = useUpdateSMSTemplate(noOpHandlers);
  const [updatePushTemplate] = useUpdatePushTemplate(noOpHandlers);

  return (messageMedium: string) =>
    match(messageMedium)
      .with(MessageMedium.Email, () => updateEmailTemplate)
      .with(MessageMedium.SMS, () => updateSMSTemplate)
      .with(MessageMedium.Push, () => updatePushTemplate)
      .otherwise(() => () => Promise.reject(new Error('Message medium not supported')));
};
